export default __webpack_public_path__ + "static/media/bild02.ca843de2.webp";